/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningstitle1Inputs */

const en_earningstitle1 = /** @type {(inputs: Earningstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earnings`)
};

const de_earningstitle1 = /** @type {(inputs: Earningstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einnahmen`)
};

/**
* | output |
* | --- |
* | "Earnings" |
*
* @param {Earningstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningstitle1 = /** @type {((inputs?: Earningstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningstitle1(inputs)
	return de_earningstitle1(inputs)
});
export { earningstitle1 as "earningsTitle" }